import React from 'react';

function Tick({ height = 7, width = 9, color = '#000000', ...props }) {
  return (
    <svg width={width} height={height} viewBox="0 0 9 7" {...props}>
      <title>{'\uD83C\uDFA8 Icon \u0421olor'}</title>
      <path
        d="M3.298 7a.554.554 0 01-.41-.184L.153 3.796a.598.598 0 01.024-.825.548.548 0 01.795.026l2.32 2.561L8.023.19a.549.549 0 01.795-.037.599.599 0 01.036.823L3.713 6.81a.553.553 0 01-.41.19h-.005z"
        fill={color}
        fillRule="nonzero"
      />
    </svg>
  );
}

export default Tick;
